import React, { type ReactNode } from "react";
import { ThemeProvider as OmegaThemeProvider, useTheme as useOmegaTheme, type ThemeContextValue } from "@omega/theme/react";

import { THEME_STORAGE_KEY, THEMES } from "./themes.registry";

import "@omega/theme/styles/spp-ui-bridge.css";
import "./legacy-css-aliases.css";

/**
 * App-обёртка над `@omega/theme/react`: реестр пресетов ompmobile + storage key.
 */
export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    return (
        <OmegaThemeProvider themes={THEMES} defaultThemeId="mobile" storageKey={THEME_STORAGE_KEY}>
            {children}
        </OmegaThemeProvider>
    );
};

/**
 * Доступ к текущей теме. Только внутри {@link ThemeProvider}.
 */
export function useTheme(): ThemeContextValue {
    return useOmegaTheme();
}
